import { storeGetSetup, storeSelect } from "./store";
import { countriesGet, storesGetList, storesSelectCountry } from "./stores";

export const PRESELECTED_STORE_LOADING = 'PRESELECTED_STORE_LOADING';
export const PRESELECTED_STORE_SUCCESS = 'PRESELECTED_STORE_SUCCESS';
export const PRESELECTED_STORE_ERROR = 'PRESELECTED_STORE_ERROR';

const loading = () => ({ type: PRESELECTED_STORE_LOADING });
const success = () => ({ type: PRESELECTED_STORE_SUCCESS });
const error = () => ({ type: PRESELECTED_STORE_ERROR });

const redirect = () => {
    window.location.href = '/';
}

export const preselectedStoreStartRequests = (country, storeId) => async (dispatch) => {
    dispatch(loading());
    const countries = await dispatch(countriesGet());
    if (!countries || !countries.find(c => c.id === country)) {
        return redirect();
    }
    dispatch(storesSelectCountry({ id: country }));

    const stores = await dispatch(storesGetList({ id: country }));
    if (!stores || !stores.find(s => s.id === storeId)) {
        return redirect();
    }
    dispatch(storeSelect(storeId));

    const storeSetup = await dispatch(storeGetSetup(storeId));
    if (storeSetup === false) {
        return redirect();
    }

    dispatch(success());
}


// WEBPACK FOOTER //
// ./src/store/actions/preselectedStore.js